import { MemberType } from 'api/models';

export enum PermissionSetObjectType {
  Account = 'ACCOUNT',
  Project = 'PROJECT',
}

export enum ProjectPermissionSetType {
  Owner = 2,
  VendorCollaborator = 3,
  CustomerCollaborator = 4,
  CustomerChampion = 5,
  Observer = 6,
}

export interface PermissionSetBase {
  permissionSetName: string;
  permissionSetSpecificTo: MemberType;
  default: boolean;
}

export interface ProjectPermissionSet extends PermissionSetBase {
  permissionSetType: ProjectPermissionSetType;
  permissionSetObjectType: PermissionSetObjectType.Project;
  permissionSetId: number;
}

export enum AccountPermissionSetType {
  Admin = 1,
  SuperUser = 7,
  VendorCollaborator = 8,
  CustomerCollaborator = 10,
  PartnerAdmin = 11,
  PartnerMember = 12,
  PartnerCollaborator = 13,
  PesPmo = 100,
  Finance = 102,
  Management = 104,
  RegionalManager = 106,
  ProjectManager = 108,
  User = 110,
  Director = 112,
  CustomerSuccess = 114,
  CustomerPartnerAdmin = 20,
  CustomerPartnerCollaborator = 22,
}

export const DEFAULT_ACCOUNT_PERMISSION_SET = [
  AccountPermissionSetType.SuperUser,
  AccountPermissionSetType.VendorCollaborator,
];

export const DEFAULT_PROJECT_PERMISSION_SET = [
  ProjectPermissionSetType.Owner,
  ProjectPermissionSetType.CustomerChampion,
];

export interface AccountPermissionSet extends PermissionSetBase {
  permissionSetType: AccountPermissionSetType;
  permissionSetObjectType: PermissionSetObjectType.Account;
  permissionSetId: number;
}

export type PermissionSet = AccountPermissionSet | ProjectPermissionSet;
